import styled from "styled-components";
import { Link } from "react-router";

export const Styledloginbg = styled.div`
  background-color: rgb(243, 243, 243);
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledLoginMainContent = styled.div`
  background-color: #ffffff;
  max-width: 425px;
  width: 95%;
  min-height: 528px;
  border-radius: 41px;
`;

export const StyledLoginMainHeading = styled.p`
  font-family: Poppins;
  font-weight: 600;
  font-size: 30px;
  text-align: center;
  vertical-align: middle;
  color: #1e1e1e;
  margin-top: 50px;
`;
export const StyledLoginName = styled.p`
  font-family: Poppins;
  font-weight: 400;
  font-size: 16px;
  vertical-align: middle;
  margin-top: 65px;
  margin-left: 29px;
`;
export const StyledLoginNameInput = styled.input`
  height: 50px;
  width: 365px;
  margin-top: 2px;
  border-radius: 6px;
  border-width: 1px;
  background-color: #fcfcfc;
  margin-left: 29px;
  border: 1px solid #9c9c9c;
  padding: 6px;
  font-size: 18px;
  outline: none;
`;
export const StyledLoginPassword = styled.p`
  font-family: Poppins;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  margin-top: 32px;
  margin-left: 29px;
`;
export const StyledLoginPasswordInput = styled.input`
  height: 50px;
  width: 365px;
  border-radius: 6px;
  border-width: 1px;
  background-color: #fcfcfc;
  margin-left: 29px;
  border: 1px solid #9c9c9c;
  outline: none;
  padding: 6px;
  font-size: 18px;
  margin-top: 2px;
`;
export const StyledLoginForgotPassword = styled(Link)`
  font-family: Poppins;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  margin-left: 245px;
  margin-top: 5px;
  text-decoration: none;
  color: black;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;
export const StyledLoginButtonLogin = styled.button`
  width: 367px;
  height: 64px;
  background: #4b49ac;
  border-radius: 6px;
  border: 0;
  margin-top: 40px;
  margin-left: 29px;
  font-family: Poppins;
  font-weight: 550;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: white;
  &:hover {
    cursor: pointer;
    background: rgb(44, 43, 117);
  }
`
export const  StyledLoginAsSuperAdmin = styled(Link)`
font-family: Poppins;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  margin-top: 40px;
  margin-bottom: 25px;
  display: flex;
  justify-content: center;
  color: #9C9C9C;
  &:hover {
    cursor: pointer;
    
  }
`
